import { Actions } from 'vuex-smart-module';
import { AxiosResponse } from 'axios';
import { Filters, FiltersPagination } from '@/types';
import { prepare_formdata } from '@/utils/index';
import { MarketingFundService } from '../service';
import MarketingFundState from './state';
import MarketingFundMutations from './mutations';
import MarketingFundGetters from './getters';
import { MarketingFund } from '../types';

const marketingFundService = new MarketingFundService();

export default class MarketingFundActions extends Actions<
  MarketingFundState,
  MarketingFundGetters,
  MarketingFundMutations,
  MarketingFundActions
> {
  async get_aplications(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.aplication_filters,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_APLICATIONS(true);
      const { data, meta } = await marketingFundService.get_aplications(payload);

      this.mutations.SET_APLICATIONS(data.items);
      this.mutations.SET_MF_LIMIT(data.marketing_fund_limit);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_APLICATIONS(false);
    }
  }

  async get_events(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.events_filters,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_EVENTS(true);
      const { data, meta } = await marketingFundService.get_events(payload);

      this.mutations.SET_EVENTS(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_EVENTS(false);
    }
  }

  async get_events_of_application() {
    try {
      const { page = 1, itemsPerPage = 10 } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: {
          ...this.state.events_filters,
          request_id: this.state.current_application_id,
        },
        pagination: {
          limit: itemsPerPage,
          page,
        },
      };

      // if (sortBy?.length) {
      //   [payload.pagination.sort] = sortBy;
      // }

      // if (sortDesc?.length) {
      //   payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      // }

      this.mutations.TOGGLE_LOADING_EVENTS(true);
      const { data, meta } = await marketingFundService.get_events_of_application(payload);

      this.mutations.SET_EVENTS_BY_APLICATION(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_EVENTS(false);
    }
  }

  async get_aplication_by_id() {
    try {
      this.mutations.TOGGLE_LOADING_EVENTS(true);
      const data = await marketingFundService.get_aplication_by_id(this.state.current_application_id);

      this.mutations.SET_APLICATION(data.data);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_EVENTS(false);
    }
  }

  async get_event_by_id() {
    try {
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.events_filters,
        pagination: {
          limit,
          page: current_page,
        },
      };

      const { data, code } = await marketingFundService.get_event_by_id(this.state.current_event_id);

      this.mutations.SET_CURRENT_EVENT(data);
      return code;
    } catch (error) {
      console.error(error);
    } finally {
      // this.mutations.TOGGLE_LOADING_NOTIFS(false);
    }
  }

  async get_history_of_application() {
    try {
      const { page = 1, itemsPerPage = 10 } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.events_filters,
        pagination: {
          limit: itemsPerPage,
          page,
        },
      };

      const { data, meta } = await marketingFundService.get_history_of_application(payload, this.state.current_application_id);

      this.mutations.SET_EVENTS_HISTORY_BY_APLICATION(data);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    }
  }

  async add_aplication() {
    try {
      const data = await marketingFundService.add_aplication();

      this.mutations.UPD_APPLICATION_ID(data.data.id);
      this.mutations.SET_APLICATION(data.data);
      this.mutations.SET_CREATE_APPLICATION_VISIBLE_MODEL(true);
    } catch (error: any) {
      console.error(error);

      if (error.data.code === 409) {
        if (error.data.message.includes('уже создана')) {
          this.mutations.UPD_APPLICATION_ID(error.data.data.id);
          this.mutations.SET_CREATED_APPLICATION_MESSAGE(error.data.message);
          this.state.already_created_visible_model = true;
        } else {
          this.state.not_created_visible_model = true;
        }
      }
    }
  }

  async delete_event(event_id: string | number) {
    try {
      const data = await marketingFundService.delete_event(event_id);

      if (this.state.current_application_id === 0) {
        await this.actions.get_events();
      } else {
        await this.actions.get_events_of_application();
        await this.actions.get_aplication_by_id();
      }

      const code = data.status;

      return code;
    } catch (error) {
      console.error(error);
    }
  }

  async add_event() {
    const new_payload = { ...this.state.new_event };

    delete new_payload.mf_event_layout_design;
    delete new_payload.mf_event_participants_list;
    delete new_payload.mf_event_pre_expenses;
    delete new_payload.mf_event_pre_program;
    delete new_payload.size_audience_reached_name;

    try {
      const payload: MarketingFund.EventPayload = {
        request: JSON.stringify(new_payload),
      };

      if (this.state.user_list_file && this.state.user_list_file !== null) {
        payload.mf_event_participants_list = this.state.user_list_file;
      }

      if (this.state.pre_programm_file && this.state.pre_programm_file !== null) {
        payload.mf_event_pre_program = this.state.pre_programm_file;
      }

      if (this.state.pre_expenses_file && this.state.pre_expenses_file !== null) {
        payload.mf_event_pre_expenses = this.state.pre_expenses_file;
      }

      if (this.state.event_layout_design_file && this.state.event_layout_design_file !== null) {
        payload.mf_event_layout_design = this.state.event_layout_design_file;
      }

      const payload_formdata = prepare_formdata(payload);

      const data = await marketingFundService.add_event(payload_formdata, this.state.current_application_id);

      if (data.data.status?.slug === 'draft') {
        this.mutations.SET_TEMPLATE_MODAL_VISIBLE(true);
      } else {
        this.mutations.UPD_EVENT_CREATED(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async edit_event(sent_to_atol?: boolean) {
    const new_payload = { ...this.state.new_event };

    delete new_payload.mf_event_layout_design;
    delete new_payload.mf_event_participants_list;
    delete new_payload.mf_event_pre_expenses;
    delete new_payload.mf_event_pre_program;
    delete new_payload.size_audience_reached_name;

    if (sent_to_atol) {
      new_payload.send_to_atol = true;
    }

    try {
      const payload: MarketingFund.EditEventPayload = {
        request: JSON.stringify(new_payload),
      };

      if (this.state.user_list_file && this.state.event_files_from_server.user_list_file.length === 0) {
        payload.mf_event_participants_list = this.state.user_list_file;
      }

      if (this.state.pre_programm_file && this.state.event_files_from_server.pre_programm_file.length === 0) {
        payload.mf_event_pre_program = this.state.pre_programm_file;
      }

      if (this.state.pre_expenses_file && this.state.event_files_from_server.pre_expenses_file.length === 0) {
        payload.mf_event_pre_expenses = this.state.pre_expenses_file;
      }

      if (this.state.event_layout_design_file
        && this.state.event_files_from_server.event_layout_design_file.length === 0) {
        payload.mf_event_layout_design = this.state.event_layout_design_file;
      }

      const payload_formdata = prepare_formdata(payload);

      const id = this.state.current_application_id;
      const event_id = this.state.current_event_id;

      const data = await marketingFundService.edit_event(payload_formdata, event_id, id);

      // if (data.code === ResponseStatuses.Success.CREATED) {
      //   this.mutations.ADD_EVENT({
      //     ...data,
      //     // id: data.data.client_id,
      //   });
      // }

      if (data.data.status && data.data.status?.slug === 'draft') {
        this.mutations.SET_TEMPLATE_MODAL_VISIBLE(true);
      } else if (data.data.status && data.data.status?.slug === 'waiting_approval') {
        this.mutations.SET_SEND_EVENT_TO_ATOL_MODAL(true);
      } else {
        this.mutations.UPD_EVENT_CHANGED(true);
      }

      return data.code;
    } catch (error) {
      console.error(error);
    }
  }

  async get_event_types_list() {
    try {
      const { data } = await marketingFundService.get_event_types_list();

      this.mutations.SET_EVENT_TYPES_LIST(data.items);
    } catch (error) {
      console.error(error);
    }
  }

  async add_event_report(approval?: boolean) {
    const new_payload = { ...this.state.new_report_form };

    if (approval) {
      new_payload.send_to_atol = true;
    }

    try {
      const payload: MarketingFund.ReportForm = { ...new_payload };

      const event_id = this.state.current_event_id;

      const data = await marketingFundService.add_event_report(event_id, payload);

      if (approval && data.code === 202) {
        this.mutations.SET_TEMPLATE_MODAL_VISIBLE(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Получение отчетов по мероприятию
   */
  async get_event_reports(flag?: string) {
    const event_id = this.state.current_event_id;

    try {
      const { data } = await marketingFundService.get_event_reports(event_id);

      if (flag) {
        this.mutations.SET_EVENT_REPORTS_FILES(data);
      } else {
        this.mutations.SET_EVENT_REPORTS(data);
      }
      if (flag === 'all') {
        this.mutations.SET_EVENT_REPORTS_FILES(data);
        this.mutations.SET_EVENT_REPORTS(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Удаление файла
   */
  async delete_file(id: number) {
    try {
      const event_id = this.state.current_event_id;

      await marketingFundService.delete_file(id, event_id);

      this.dispatch('get_event_reports', 'delete');
      this.dispatch('get_event_by_id');
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Добавление файлов на сервер
   */
  async mf_event_confirming_documents(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_confirming_documents: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_agreement(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_agreement: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_banner_mockup(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_banner_mockup: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_program(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_program: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_participants_list(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_participants_list: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_expenses(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_expenses: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  async mf_event_final_design(value: File) {
    try {
      const event_id = this.state.current_event_id;
      const payload = {
        mf_event_final_design: value,
      };

      const payload_form_data = prepare_formdata(payload);

      const { data } = await marketingFundService.add_files(event_id, payload_form_data);

      this.dispatch('get_event_reports', 'files');
    } catch (error) {
      console.error(error);
    }
  }

  /** Отправка заявки в АТОЛ */
  async send_to_atol_for_approval() {
    try {
      const id = this.state.current_application_id;
      const { data } = await marketingFundService.send_to_atol_for_approval(id);

      await this.dispatch('get_events_of_application');

      this.mutations.SET_APLICATION(data);
      this.state.sent_to_atol_available_visible_model = true;
    } catch (error) {
      console.error(error);
    }
  }

  /** Запрос списка - Размер охваченной аудитории */
  async get_size_audience_reached() {
    try {
      const { data } = await marketingFundService.get_size_audience_reached();

      this.mutations.UPD_SIZE_AUDIENCE_REACHED_LIST(data.items);
    } catch (error) {
      console.error(error);
    }
  }
}
